module.exports = __webpack_public_path__ + "images/f8a0bb6b76d832bc14d8b0da681da5ca.svg";